export const MY_BLOGS = [
  {
    icon: "fas fa-user",
    name: "Fullname",
    text: "Ulug'bek Bozarov",
  },
  {
    icon: "far fa-calendar-alt",
    name: "Birthday",
    text: "08.01.1999",
  },
  {
    icon: "fas fa-phone-alt",
    name: "Phone",
    text: "+998 (94) 499-89-94",
  },
  {
    icon: "fas fa-envelope",
    name: "Email",
    text: "ulugbek01081999@gmail.com",
  },
];

export const MY_INTERESTS = [
  {
    icon: "fas fa-code",
    text: "Coding",
  },
  {
    icon: "fas fa-swimmer",
    text: "Swimming",
  },
  {
    icon: "fas fa-film",
    text: "Movie",
  },
];
